import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { STATUS_NS } from './helpers';

// #174: the display name of a status. A shop label or a neutral name that is
// just the status code (the seeded labels, or no label in the language) is no
// name: the portal shows its own translation of the type. A hook so the
// orphan-key scanner sees the literal t('key') reads of useTranslation's t.
export const useStatusName = () => {
  const { t } = useTranslation();
  return useCallback(
    (
      status: { id: number; name: string; type?: string },
      shopLabels: boolean
    ): string => {
      if (shopLabels) {
        const shop = t(`${STATUS_NS}:return_status_${status.id}.name`, {
          defaultValue: '',
        });
        if (shop.trim() && shop !== status.type) return shop;
      }
      const name = status.name ?? '';
      if (name.trim() && name !== status.type) return name;
      switch (status.type) {
        case 'NEW':
          return t('tracking.statusType.NEW');
        case 'APPROVED':
          return t('tracking.statusType.APPROVED');
        case 'AWB_GENERATED':
          return t('tracking.statusType.AWB_GENERATED');
        case 'ON_THE_WAY':
          return t('tracking.statusType.ON_THE_WAY');
        case 'RECEIVED':
          return t('tracking.statusType.RECEIVED');
        case 'TO_BE_PAID':
          return t('tracking.statusType.TO_BE_PAID');
        case 'PENDING_ACTION':
          return t('tracking.statusType.PENDING_ACTION');
        case 'COMPLETED':
          return t('tracking.statusType.COMPLETED');
        case 'CANCELLED':
          return t('tracking.statusType.CANCELLED');
        default:
          return name;
      }
    },
    [t]
  );
};
